export default "/images/vendor/flag-icons/flags/4x3/ke.svg?0aab796123b74534bf3754455dfc308b";